export default __webpack_public_path__ + "static/media/createOrg.1933cb26.png";